import '../public/sso'; //日期格式化插件
import locale from './lang';
import config from '../package.json';
import router from './router';
import './directive.js';
import Print from "./plugs/print";
import Formulas from "./formulas";
import VueAMap from 'vue-amap'; //高德地图插件
import VueClipboard from 'vue-clipboard2';
import Viewer from 'v-viewer'; //图片预览插件
import 'viewerjs/dist/viewer.css';
import VueUeditorWrap from 'vue-ueditor-wrap'; //引入富文本组件
import echarts from 'echarts'; //引入echarts
import Video from 'video.js';
import 'video.js/dist/video-js.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import req from "./request";
import moment from 'moment'; //日期格式化插件
import store from './store';

var comObj = {
    src: {},
    version: config.version,
    locale: locale.use,
    i18n: locale.i18n,
    router: router,
    store: store,
    request: req
};
var ignoeKeys = Object.keys(comObj);
var ignoeFile = ['./main.js', './index.js', './utils/cleanFiles.js', './utils/fileUtil.js'];
const getRootFilePaths = () => {
    var componentPaths = []
    if (componentPaths.length == 0) {
        const requireAll = require.context("@", true, /(?<!(main))(.vue$|.js$)/);
        const srcKeys = requireAll.keys();
        var out = [], names = [];
        for (let i = 0; i < srcKeys.length; i++) {
            const componentPath = srcKeys[i];
            if (ignoeFile.indexOf(componentPath) == -1) {
                if (componentPath.lastIndexOf('.vue') == componentPath.length - 4) {
                    var file = componentPath.replace('./', "src/").replace(/\.vue$/, "");
                    var file2 = componentPath.replace('./', "@/").replace(/\.vue$/, "");
                    comObj.src[componentPath] = requireAll(componentPath).default;
                    comObj.src[file] = comObj.src[componentPath];
                    comObj.src[file + '.vue'] = comObj.src[componentPath];
                    comObj.src[file2] = comObj.src[componentPath];
                    comObj.src[file2 + '.vue'] = comObj.src[componentPath];
                    file = componentPath.substring(componentPath.lastIndexOf("/") + 1, componentPath.lastIndexOf(".vue"));
                    file = file.substring(0, 1).toLocaleUpperCase() + file.substring(1);
                    comObj[file] = comObj.src[componentPath];
                } else {
                    var file = componentPath.replace('./', "src/").replace(/\.js$/, "");
                    var file2 = componentPath.replace('./', "@/").replace(/\.js$/, "");
                    comObj.src[componentPath] = requireAll(componentPath).default;
                    comObj.src[file] = comObj.src[componentPath];
                    comObj.src[file + '.js'] = comObj.src[componentPath];
                    comObj.src[file2] = comObj.src[componentPath];
                    comObj.src[file2 + '.js'] = comObj.src[componentPath];
                }
            }
        }
    }
}
getRootFilePaths();
const HaloseeUiFvue = comObj;
console.debug('[HaloseeUiFvue]：', HaloseeUiFvue);

HaloseeUiFvue.import = (path = {}) => {
    let src = HaloseeUiFvue.src[path];
    if (!src) {
        console.warn('[HaloseeUiFvue]', path + '未找到对应资源')
    }
    return src;
}

HaloseeUiFvue.install = (Vue, opts = {}) => {
    if (!opts.smallScreenDialog) {
        opts.smallScreenDialog = false;
    }
    if (!opts.paginationBackground) {
        opts.paginationBackground = false
    }
    if (!opts.readonlyInput) {
        opts.readonlyInput = false
    }
    if (!opts.extProps) {
        opts.extProps = {};
    }
    Vue.prototype.$smallScreenDialog = opts.smallScreenDialog;
    Vue.prototype.$paginationBackground = opts.paginationBackground;
    Vue.prototype.$readonlyInput = opts.readonlyInput;
    Vue.prototype.$extProps = opts.extProps;

    let components = []
    Object.keys(HaloseeUiFvue).forEach(name => {
        if (ignoeKeys.indexOf(name) == -1) {
            try {
                if (typeof (Vue.component(name)) !== 'function') {
                    if(name=="Index"&&HaloseeUiFvue[name].name){
                        Vue.component(HaloseeUiFvue[name].name, HaloseeUiFvue[name]);
                    }else{
                        Vue.component(name, HaloseeUiFvue[name]);
                    }
                    components.push(name);
                }
            } catch (e) {
                console.warn('Vue.component', name, e);
            }
        }
    });
    console.debug('[HaloseeUiFvue]注册component列表', components);
    Vue.prototype.$video = Video;

    Vue.config.debug = true;

    Vue.prototype.$http = req;

    Vue.use(Viewer, {
        defaultOptions: {
            zIndex: 9999,
            toolbar: true,
        },
    });
    Vue.use(VueClipboard);
    Vue.use(Print);
    Vue.use(Formulas);
    // Vue.component('HtSubmitButton', HaloseeUiFvue.HtSubmitButton);
    // Vue.component('HtDeleteButton', HaloseeUiFvue.HtDeleteButton);
// 注册全局组件
    Vue.use(VueAMap);
    Vue.filter('formatDate', function (value, pattern = 'YYYY-MM-DD HH:mm:ss') {
        if (!value) {
            return '';
        }
        return moment(value).format(pattern);
    });
    Vue.component('vue-ueditor-wrap', VueUeditorWrap);
    Vue.component(CollapseTransition.name, CollapseTransition);

    Vue.prototype.$echarts = echarts;
}

if (typeof window !== 'undefined' && window.Vue) {
    HaloseeUiFvue.install(window.Vue);
}

export default HaloseeUiFvue;
